import { render, staticRenderFns } from "./RecentGamesFilter.vue?vue&type=template&id=6185a74a&"
import script from "./RecentGamesFilter.vue?vue&type=script&lang=js&"
export * from "./RecentGamesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports